import { z as e } from "./index-tuEhcVD3.mjs";
const s = "smart-adb_context", r = "smart-login_user_details", i = "smart-cart", o = /^[a-zA-Z0-9._-]*$/, a = e.object({
  accessToken: e.string().regex(o),
  refreshToken: e.string().regex(o),
  idToken: e.string().regex(o),
  uid: e.string().regex(o),
  organisationId: e.string().regex(o).optional(),
  userId: e.string().email(),
  ecomAccessToken: e.string().regex(o)
}), n = e.object({
  customerUserId: e.string().email().optional(),
  customerPreferredLang: e.string().regex(o).optional(),
  customerType: e.string().regex(o).optional(),
  customerUUID: e.string().regex(o).optional()
}), g = e.object({
  guid: e.string().optional(),
  code: e.string().optional()
});
export {
  s as a,
  o as b,
  i as c,
  a as d,
  n as e,
  g as f,
  r as l
};
//# sourceMappingURL=constants-RT-_BdF-.mjs.map
